export const routeAction = {
  setRoute: (state, action) => {
    const view = action.payload;

    switch (view) {
      case "active":
        state.route = "/transmissions";
        state.selectedTab = view;
        break;
      case "processed":
        state.route = "/transmissions/processed";
        state.selectedTab = view;
        break;
      case "clinic":
        state.route = "/transmissions/clinic";
        state.selectedTab = view;
        break;
      case "clinic-review":
        state.route = "/transmissions/clinic-review";
        state.selectedTab = view;
        break;
      case "clinic-processed":
        state.route = "/transmissions/clinic-processed";
        state.selectedTab = view;
        break;
      case "heart-failure":
        state.route = "/transmissios/heart-failure";
        state.selectedTab = view;
        break;
      // TODO: needs to be changed when end point is available
      case "signed-archived":
        state.route = "/transmissions/clinic/signed-archived";
        state.selectedTab = view;
        break;
      default:
    }
  },
};
